import * as angular from 'angular';
import controller, {CavityCorrelationGraphController} from './cavityCorrelationSummaryGraph.controller';
import template from './cavityCorrelationSummaryGraph.tpl.html';

export default angular.module('aps.directive.cavityCorrelationSummaryGraph', [controller])
  .directive('apsCavityCorrelationSummaryGraph', cavityCorrelationSummaryGraphDef)
  .name;

export interface CavityCorrelationSummaryGraphScope extends angular.IScope {
  vm: CavityCorrelationGraphController;
}

function cavityCorrelationSummaryGraphDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'CavityCorrelationSummaryGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      cavities: '=',
      cavitySelected: '=',
      showIfEmpty: '='
    },
    link: function ($scope: CavityCorrelationSummaryGraphScope) {
      $scope.$watchCollection('vm.cavities', function() {
        $scope.vm.setCavities();
        $scope.vm.setTopDefects();
      });
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/cavityCorrelationSummaryGraph.directive.ts